import { CaptureStatus } from '../../types/api';

const shouldFilterFromOnPrem = (value) =>
  value === 'annotation_events' ||
  value === 'status_pending_annotation' ||
  value === 'accuracy' ||
  value.startsWith('status_');

const COLUMN_SETS = {
  normal: ({ allOrganizations, onPrem }): Array<string> => {
    const columnSet = [
      'serial_number',
      'hardware_model',
      'doorway_name',
      'status',
      'accuracy',
      'space_name',
      'first_online',
      'os_version',
      'capture_status',
      'annotation_events',
      'qaed_event_count',
      'setup_step',

      // Add a column for each capture status
      // ...Object.keys(CaptureStatus).map(i => `status_${i}`),

      // TODO: determine if these are useful columns on the list view long term.
      // Some user personas (Leanna) seem to use them, others (Scarlett) don't
      // 'salesforce_opp_id',
      // 'salesforce_opportunity_name',
      // 'salesforce_opportunity_closed_date',
      // 'salesforce_opportunity_shipped_date',
      // 'salesforce_account_name',
      // 'salesforce_account_account_type',
      // 'salesforce_opportunity_number_of_dpus',
    ];

    // If all organizations is selected, display the organization name
    if (allOrganizations) {
      columnSet.splice(2, 0, 'organization_name');
    }

    // remove the on prem list filter list if ON_PREM is enabled
    return columnSet.filter((col) => !(onPrem && shouldFilterFromOnPrem(col)));
  },
  sidebar: ({ onPrem }): Array<string> => {
    const columnSet = [
      'serial_number',
      'doorway_name',
      'status',
      'annotation_events',
      'status_pending_annotation',
      'accuracy',
    ];

    // remove the on prem list filter list if ON_PREM is enabled
    return columnSet.filter((col) => !(onPrem && shouldFilterFromOnPrem(col)));
  },
};

export default COLUMN_SETS;
